module.exports = require('./src/master_gateway');